import React from "react";
import { shopifyLogin } from "../utils/auth";

const LoginButton = () => {
    return (
        <div className="text-center mt-5">
            <h2>Login with Shopify</h2>
            <button className="btn btn-primary" onClick={shopifyLogin}>
                Login via Shopify
            </button>
        </div>
    );
};

export default LoginButton;
